import { isAfter } from "date-fns";
import dayjs from "dayjs";

const initialState = {
  referenceWorkRequestNo: "",
  issueDateandTimeBasicDetails: "",
  workorderDateandTime: "",
  requestor: "",
  designation: "",
  contactNo: "",
  assetNo: "",
  oldAssetNo: "",
  description: "",
  underwarrenty: "",
  location: "",
  workgroupDescription: "",
  requestDetails: "",
  recivedDateandTime: "",
  category: { key: "option1", label: "Unscheduled", isvisible: true, id: 1 },
  type: { key: "option1", label: "Breakdown", isvisible: true, id: 1, femworkordercategoryId: 1 },
  priority: { key: 'option1', label: 'Normal', isvisible: true, id: 1 },
  targetResponse: "120 Mins",
  cancelledBy: "",
  reasonforCancellation: "",
  ppmscheduletrackId: "",
  pdmscheduletrackId: "",
  performancetest: "",
  electricalsafteytest: "",
  processstatus: "",
  partReplacementRows: [],
  completionInfo: {
    respondedBy: "",
    designation: "",
    respondedDateandTime: "",
    duration: "",
    downTimeHours: "",
    completionBy: "",
    startDateandTime: "",
    endDateandTime: "",
    actionTaken: "",
    signatureFiles: [],
    costInfo: {
      editmode: false,
      breakDownCost: "",
      poNumber: "",
      ppmCostByPurchaseOrder: "",
      poNumberByPurchaseOrder: "",
      ppmCostByContract: "",
      contractReferenceNumber: "",
      totalSparePartCost: "",
      totalWorkorderCost: "",
    }
  },
  assessments: {
    respondedBy: "",
    designation: "",
    respondedStartDateandTime: "",
    respondedEndDateandTime: "",
    decontaminationNotice: "",
    taskCode: "",
    taskDescription: "",
    repairType: "",
    partsRequired: "",
    assetTakenLocation: "",
    respondedFinding: "",
    vendor: "",
    outsourceRespondRemarks: "",
    repairTracker: []
  },
  vendorField: false,
  editmode: false,
  formSubmitStatus: true,
  timeStamp: "",
  isAutoAssign: "",
  isTransfer: false,
  transfertoId: "",
  isAfterImageAttachmentUploaded: false,
  Closeddate: "",
  Closedid: "",
  completedby: "",
  completeddate: ""
};



const workOrderBasicDetailsReducer = (state = initialState, action) => {

  switch (action.type) {
    case 'UPDATE_BASIC_DETAILS_WORK_ORDER_SUMMARY':
      return {
        ...state,
        ...action.payload,
      };
    case 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY':
      return initialState;


    case 'CREATE_ASSESMENTS':
      return {
        ...state,
        assessments: {
          ...state.assessments,
          ...action.payload,
          repairTracker: state.assessments.repairTracker
        }
      };

    case 'ADD_REPAIR_TRACKER_DETAILS':
      return {
        ...state,
        assessments: {
          ...state.assessments,
          repairTracker: [
            ...state.assessments.repairTracker,
            action.payload,
          ],
        },
      };

    case 'UPDATE_REPAIR_TRACKER_DETAILS':

      if (action.payload?.dummy_id) {
        return {
          ...state,
          repairTracker: state?.assessments?.repairTracker?.map((data) =>
            data?.dummy_id === action?.payload?.dummy_id
              ? { ...data, ...action.payload }
              : data
          ),
        };
      } else if (action.payload?.id) {
        return {
          ...state,
          repairTracker: state?.assessments?.repairTracker?.map((data) =>
            data?.id === action?.payload?.id
              ? { ...data, ...action.payload }
              : data
          ),
        };
      } else {
        return;
      }

    case 'DELETE_REPAIR_TRACKER':
      if (action?.payload?.dummy_id) {
        return {
          ...state,
          assessments: {
            ...state.assessments,
            repairTracker: state.assessments.repairTracker?.filter(
              (item) => item?.dummy_id !== action?.payload?.dummy_id
            ),
          },
        };
      } else if (action?.payload?.id) {
        return {
          ...state,
          assessments: {
            ...state.assessments,
            repairTracker: state.assessments.repairTracker?.filter(
              (item) => item?.id !== action?.payload?.id
            ),
          },
        };
      } else {
        return state;
      }


    case "CLEAR_REPAIRTRACKER":
      return {
        ...state,
        assessments: {
          ...state.assessments,
          repairTracker: [],
        },
      }

    case 'PART_REPLACEMENT':
      return {
        ...state,
        partReplacementRows: [
          ...state.partReplacementRows,
          action.payload,
        ],
      };

    case 'UPDATE_PART_REPLACEMENT':
      if (action.payload?.dummy_id) {
        return {
          ...state,
          partReplacementRows: state.partReplacementRows.map((item) =>
            item?.dummy_id === action?.payload?.dummy_id
              ? { ...item, ...action.payload }
              : item
          ),
        };
      } else if (action.payload?.id) {
        return {
          ...state,
          partReplacementRows: state.partReplacementRows.map((item) =>
            item?.id === action?.payload?.id
              ? { ...item, ...action.payload }
              : item
          ),
        };
      } else {
        return;
      }

    case 'DELETE_PART_REPLACEMENT':
      if (action?.payload?.dummy_id) {
        return {
          ...state,
          partReplacementRows: state?.partReplacementRows?.filter(
            (item) => item?.dummy_id !== action?.payload?.dummy_id
          ),
        };
      } else if (action?.payload?.id) {
        return {
          ...state,
          partReplacementRows: state?.partReplacementRows?.filter(
            (item) => item?.id !== action?.payload?.id
          ),
        };
      } else {
        return;
      };


    case 'CLEAR_PART_REPLACEMENT':
      return {
        ...state,
        partReplacementRows: []
      };

    case 'CREATE_COMPLETIONINFO':
      return {
        ...state,
        completionInfo: {
          ...state.completionInfo,
          ...action.payload,
          costInfo: { ...state.completionInfo.costInfo }, // Ensure costInfo remains intact
        }
      };


    case 'CREATE_COST_INFO':
      return {
        ...state,
        completionInfo: {
          ...state.completionInfo,
          costInfo: {
            ...state.completionInfo.costInfo,
            ...action.payload,
          }
        }
      };

    case 'SET_VENDORFIELD':
      return {
        ...state,
        vendorField: action.payload
      }


    case 'CHECK_FORMSUBMITTED_WORKORDER':
      return {
        ...state,
        formSubmitStatus: action?.payload
      }

    case 'CHECK_ISASFTER_IMAGE_ATTACHMENT_UPLOADED':
      // console.log("Action Payload:", action?.payload);
      // console.log("State Payload:", state);


      return {
        ...state,
        isAfterImageAttachmentUploaded: action?.payload
      }


    default:
      return state;
  }
};

export default workOrderBasicDetailsReducer;